lmApp
  .controller('TileLogoController', ['$scope', '$rootScope', '$interval', 'ShowcaseService', 'ToastService',
    function ($scope, $rootScope, $interval, ShowcaseService, ToastService) {

      $scope.namespace = 'stockmob';
      $scope.tile = $scope.$parent.tile;
      $scope.loading = false;

      $scope.watcher = $scope.$watch('tile.banner._PrivateData.picture', function (newValue, oldValue) {
        if (oldValue && newValue !== oldValue) {
          if ($scope.tile.isNew) {
            ShowcaseService.CreateLogoWidget($scope.tile.banner, $scope.namespace)
              .then(function (response) {
                $scope.tile.banner.id = response.widget.id;

                if (item._PrivateData.isSliderInner) {
                  $scope.$parent.createNewSliderItem($scope.tile)
                } else {
                  $scope.$parent.createNewTile($scope.tile);
                }
              })
              .catch(function (reason) {
                $rootScope.hideLinearProgress('#showcasesLoader');
                ToastService.Small({
                  title: 'App logo create failed',
                  color: 'red',
                  icon: 'image-area'
                });
                $rootScope.debugInfo(reason);
              });
          } else {
            ShowcaseService.UpdateLogoWidget($scope.tile.banner)
              .then(function (response) {
                $rootScope.hideLinearProgress('#showcasesLoader');
                ToastService.Small({
                  title: 'App logo successfully updated',
                  color: 'green',
                  icon: 'image-area'
                });
              })
              .catch(function (reason) {
                $rootScope.hideLinearProgress('#showcasesLoader');
                ToastService.Small({
                  title: 'App logo update failed',
                  color: 'red',
                  icon: 'image-area'
                });
                $rootScope.debugInfo(reason);
              });
          }
        }
      });

      $scope.$on('$destroy', function () {
        $scope.watcher();
      })

    }]);
